import { maxWidth } from "@/assets/styles/mixins.css.js";
import styled from "styled-components";
import vars from "@/assets/styles/vars";

const MainGallery = styled.div`
  width: 944px;
  height: 100%;
  max-height: 520px;
  max-width: 100%;
  aspect-ratio: 1.82 / 1;
  margin-bottom: 40px;
  position: relative;
  margin-left: auto;
  margin-right: auto;

  .swiper-container {
    overflow: visible;
    width: 100%;

    ${maxWidth(vars.breakpoints.xsDesktop)`
         margin:0;
      `}
  }

  .swiper-pagination {
    display:none;
    ${maxWidth(vars.breakpoints.mTablet)`
      display:flex;
      top:unset;
      bottom:20px;
      left:20px;
      gap:15px;  
    `}
  }

  .swiper-pagination-bullet {
    width: 7px;
    height: 7px;
    background-color: #000000;
    &:after {
      display:none;
    }
  }

  .swiper-pagination-bullet-active {
    background-color: #fff;
  }
    

  .swiper-button-next,
  .swiper-button-prev {
    width: 47px;
    height: 47px;
    border-radius: 50%;
    background: #fff;
    opacity: 1;
    top: 50%;
    background-position: center;
    background-size: auto;
    background-repeat: no-repeat;

    ${maxWidth(vars.breakpoints.mTablet)`
      display:none;
   `}
  }

  .swiper-button-next {
    right: 0;
    transform: translateY(-50%) translateX(50%);
    background-image: url("data:image/svg+xml,%3Csvg width='9' height='17' viewBox='0 0 9 17' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.807347 1.24026L8.06709 8.5L0.807347 15.7597' stroke='%23B69B64' /%3E%3C/svg%3E");
  }

  .swiper-button-prev {
    left: 0;
    transform: translateY(-50%) translateX(-50%);
    background-image: url("data:image/svg+xml,%3Csvg width='9' height='17' viewBox='0 0 9 17' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M8.19265 15.7597L0.932913 8.5L8.19265 1.24026' stroke='%23B69B64' /%3E%3C/svg%3E");
  }

  ${maxWidth(vars.breakpoints.tablet)`
      margin-bottom: 30px;
   `}
`;

MainGallery.Item = styled.div`
  transition: 0.3s ease-out;
  aspect-ratio: 1.82 / 1;

  &:not(.swiper-slide-active) {
    transform: scaleY(0.91);
  }

  ${maxWidth(vars.breakpoints.mTablet)`
      height: auto;
   `}

  ${maxWidth(vars.breakpoints.mobile)`
      height: auto;
   `}
`;

MainGallery.Img = styled.div`
  width: 100%;
  height: 100%;
  display: block;
  position: relative;

  .swiper-slide-active & {
    &:after {
      opacity: 0.1;
    }
  }

  &:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    transition: 0.3s ease-out;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export default MainGallery;
